import { Axios } from '@vivaldis/common'

Axios.config(import.meta.env.VITE_API_URL as string)
